module.exports = global["VueLoader"] = require("-!./vue.common.js");